import React from 'react';

const Required = _ => <b className="text-danger"> *</b>;

export default Required;